import PropTypes from 'prop-types'

import BrandIcon from 'public/icons/brand.svg'
import BoatIcon from 'public/icons/boat.svg'
import WaterDropIcon from 'public/icons/water-drop.svg'
import CalendarIcon from 'public/icons/calendar.svg'
import LengthIcon from 'public/icons/length.svg'
import EuroIcon from 'public/icons/euro.svg'

const BoatsFilterIcon = ({ icon }) => {
    switch (icon) {
        case 'brand':
            return <BrandIcon />
        case 'type':
            return <BoatIcon />
        case 'condition':
            return <WaterDropIcon />
        case 'year':
            return <CalendarIcon />
        case 'length':
            return <LengthIcon />
        case 'price':
            return <EuroIcon />
        default:
            return null
    }
}

BoatsFilterIcon.propTypes = {
    icon: PropTypes.string.isRequired
}

export default BoatsFilterIcon
